import React from 'react';
import ReactDOM from 'react-dom';
import CScontactForm from './page/components/CScontactForm';
import GladlyCScontactForm from './page/components/GladlyCScontactForm';
import '../../styles/templates/pages/page.cs-contact-form.scss';

function initContactForm() {
  const contactFormTarget = document.getElementById('CsContactForm');
  if (!contactFormTarget) {
    console.error('Error rendering CS contact form. Target container is not defined.');
    return;
  }
  const isGladlyCScontactFormEnabled = window.getSiteSettings && window.getSiteSettings().gladlyCScontactFormEnabled;

  if (isGladlyCScontactFormEnabled) {
    ReactDOM.render(<GladlyCScontactForm />, contactFormTarget);
  } else {
    ReactDOM.render(<CScontactForm />, contactFormTarget);
  }
}

initContactForm();
